"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOrApiAuthHeadersSchema = exports.UserAuthHeadersSchema = exports.USER_AUTH_HEADER_NAME = exports.ApiAuthHeadersSchema = exports.API_AUTH_HEADER_NAME = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
exports.API_AUTH_HEADER_NAME = 'x-api-key';
exports.ApiAuthHeadersSchema = zod_1.default.object({ [exports.API_AUTH_HEADER_NAME]: zod_1.default.string().optional() });
exports.USER_AUTH_HEADER_NAME = 'authorization';
exports.UserAuthHeadersSchema = zod_1.default.object({ [exports.USER_AUTH_HEADER_NAME]: zod_1.default.string().optional() });
exports.UserOrApiAuthHeadersSchema = zod_1.default.union([exports.UserAuthHeadersSchema, exports.ApiAuthHeadersSchema]);
